<script lang="ts" setup>
import { type Period } from '@carrefour-gcs/shared';
import type { SelectedIntervalType } from './periodSelector.model';
import { DATE_PERIOD_TO_COMPONENT } from './periodSelectorUtils';

withDefaults(
  defineProps<{
    isActive: boolean;
    name: string;
    label: string;
    period: Period;
    availableInterval: { start: Date; end: Date };
    selectedInterval: SelectedIntervalType;
    nielsenUnavailableMessage?: string;
    hideComponentWhenInactive?: boolean;
    testId?: string;
    isInvalid?: boolean;
    errorMessage?: string;
  }>(),
  {
    nielsenUnavailableMessage: undefined,
    hideComponentWhenInactive: false,
    testId: undefined,
    isInvalid: false,
    errorMessage: undefined
  }
);

const emit = defineEmits<{
  select: [];
  'update:interval': [interval: SelectedIntervalType];
}>();
</script>

<template>
  <label
    class="items-center p-4 mb-4 border rounded hover:cursor-pointer flex flex-col"
    :class="{
      'border-error': isInvalid,
      'border-primary': isActive && !isInvalid
    }"
    :data-testid="testId"
  >
    <div class="font-bold self-start flex items-center">
      <input type="radio" :checked="isActive" :name="name" class="mr-2" @change="emit('select')" />
      {{ label }}
    </div>
    <div v-if="!hideComponentWhenInactive || isActive" class="flex flex-col w-full mt-4">
      <div v-if="period === 'nielsen' && nielsenUnavailableMessage" class="text-xs text-gray-500 italic">
        {{ nielsenUnavailableMessage }}
      </div>
      <Component
        :is="DATE_PERIOD_TO_COMPONENT[period]"
        v-else-if="period !== 'nielsen'"
        :available-interval="availableInterval"
        :selected-interval="selectedInterval"
        :disabled="!isActive"
        @update-interval="emit('update:interval', $event)"
      />
      <span
        v-if="isInvalid && errorMessage"
        class="text-error text-xs mt-2 self-start"
        data-testid="comparison-error-message"
      >
        {{ errorMessage }}
      </span>
    </div>
  </label>
</template>
